import * as React from 'react'
import { MailRegular } from '@fluentui/react-icons'
import { Button, ButtonProps } from '@fluentui/react-components'

type PhoneNumberButtonProps = ButtonProps & {
    email: string
    composeEmailClick: () => void
}

export default function PhoneNumberButton(props: PhoneNumberButtonProps) {
    return (
        <Button
            size="small"
            appearance={'subtle'}
            icon={<MailRegular />}
            onClick={e => {
                e.stopPropagation()
                props.composeEmailClick()
            }}
            {...props}
        >
            {props.email}
        </Button>
    )
}
